export class DatasetResourceButtons {
  download: boolean;
  map: boolean;
  table: boolean;
  api: boolean;
  wishlist: boolean;
}
